import { useState } from "react";
import PortalPageView from "./PortalPageView";
import { useAuthContext } from "../../context/AuthContext";
import useFlowPlayer, {
  FlowPlayer,
} from "../../components/flowPlayer/FlowPlayer";
import useCustomEffect from "../../hooks/useCustomEffect";
import useEvaApi, { EvaApiCall } from "../../hooks/useEvaApi";
import { getPortalVisitorFetchParams } from "./PortalPageHelpers";
import { getFlowDataFromVisitor } from "../../components/flowPlayer/FlowPlayerHelpers";

function PortalPage() {
  const callEvaApi = useEvaApi();
  const authContext = useAuthContext();

  const [visitor, setVisitor] = useState(authContext.auth?.user?.visitor);
  const [submitted, setSubmitted] = useState(false);
  const [finished, setFinished] = useState(false);
  const [submitError, setSubmitError] = useState(null);
  const [visitorData, setVisitorData] = useState({
    visitor_id: visitor?.id,
    visitor_type_id: visitor?.visitor_type?.id,
    ...getFlowDataFromVisitor(visitor),
  });

  const flowPlayer = useFlowPlayer(
    new FlowPlayer()
      .setFlowId(visitor?.visitor_type?.portal_flow)
      .setVisitor(visitor)
      .setVisitorType(visitor?.visitor_type)
      .setVisitorState(visitorData, setVisitorData)
      .setSubmitted(submitted)
      .setOnSubmit(onSubmit)
      .setOnFlowEnd(() => setFinished(true)),
  );

  /**
   * UseEffect for initializing the flow player
   */
  useCustomEffect(() => {
    if (!flowPlayer.step) {
      flowPlayer.onNextStep();
    }
  });

  /**
   * This method will handle the flow completion event
   */
  async function onSubmit(step = null) {
    step = step || flowPlayer.step;

    await callEvaApi(
      new EvaApiCall(`visitors/sign_in/${visitor?.id}/portal`)
        .setLoadingGroup("flow_player_next_step")
        .setParams(getPortalVisitorFetchParams())
        .setMethod("POST")
        .setAlertError(false)
        .setAlertSuccess(false)
        .setData(visitorData)
        .setOnSuccess((response) => {
          const newVisitor = response.data.data;
          setVisitor(newVisitor);
          setVisitorData((prev) => ({
            ...prev,
            ...getFlowDataFromVisitor(newVisitor),
          }));

          flowPlayer.onNextStep(step);
          setSubmitted(true);
        })
        //Show the error instead of the empty process data step, so the visitor never gets stuck on a failed save
        .setOnError(setSubmitError),
    );
  }

  return (
    <PortalPageView
      visitor={visitor}
      flowPlayer={flowPlayer}
      finished={finished}
      submitError={submitError}
    />
  );
}

export default PortalPage;
